$(document).ready(function(){
  var $insurance_input = $('.insurance-checkbox input');
  
  // Cart page Insurance  
  var pathname = window.location.pathname;
  var first_visitor = localStorage.getItem('first_visitor');
  let isChecked = $insurance_input.hasClass('input-checked');
  if(pathname == '/cart'){
    if(!isChecked && first_visitor != 'false'){
      setTimeout(function() {
        $('.insurance-checkbox input').trigger('click');
      }, 2000);
    }
  }
  
  $('.insurance-checkbox input').on('click', function(){
    
    var variant_quantity = 1;
    var variant_id = $(this).attr('value');
    
    if($insurance_input.hasClass('input-checked')){
      $('.insurance-checkbox svg').hide();
      
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        async: false,
        data: {
          quantity: 0,
          id: variant_id
        },
        dataType: 'json',
        error: function(data) {
          console.log('product unavailable');
        },
        success: function (data) {
          console.log('Successfully!');
          location.reload();
          localStorage.setItem('first_visitor', 'false');
        },
        cache: false
      });
      
    } else {
      
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        async: false,
        data: {
          quantity: variant_quantity,
          id: variant_id
        },
        dataType: 'json',
        error: function(data) {
          console.log('product unavailable');
        },
        success: function (data) {
          console.log('Successfully!');
          location.reload();
        },
        cache: false
      });
    }
  });
  
});